import Link from "next/link"

import {
  NavIcon,
  navLabelAppearance,
  type NavIconName
} from "@/components/ui/nav-icon"
import { cn } from "@/lib/utils"

type ItemProps = {
  name: NavIconName
  title: string
  className?: string
  iconClassName?: string
}

type ItemLinkProps = ItemProps & {
  href: string
  isActive?: boolean
}

type ItemButtonProps = ItemProps & {
  onClick?: () => void
  pressed?: boolean
}

export function ItemLink({
  href,
  name,
  title,
  isActive = false,
  className,
  iconClassName
}: ItemLinkProps) {
  return (
    <Link
      href={href}
      className={cn(
        "flex flex-col items-center gap-[5px] overflow-visible text-white/50",
        isActive && "text-white",
        className
      )}
      aria-current={isActive ? "page" : undefined}
    >
      <NavIcon
        name={name}
        variant={isActive ? "active" : "inactive"}
        className={iconClassName}
      />
      <span
        className={cn(
          "text-[10px] font-semibold leading-none",
          isActive ? navLabelAppearance.active : navLabelAppearance.inactive
        )}
      >
        {title}
      </span>
    </Link>
  )
}

export function ItemButton({
  name,
  title,
  className,
  iconClassName,
  onClick,
  pressed
}: ItemButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={pressed}
      className={cn(
        "flex flex-col items-center gap-[5px] overflow-visible text-white/50",
        className
      )}
    >
      <NavIcon
        name={name}
        variant={pressed ? "active" : "inactive"}
        className={iconClassName}
      />
      <span className="text-[10px] font-semibold leading-none">{title}</span>
    </button>
  )
}
